<template>
  <div>
    <h5 class="cabecera">Producto</h5>
    <div class="linea">
    </div>
    <br>
    <div class="md-layout">
      <div class="md-layout-item md-size-30" md-alignment="center center">
        <img :src="getProductImageUrl()" width="100%" height="auto" />
      </div>
      <div class="md-layout-item md-size-70">
        <ul class="list-data">
          <li v-if="issue.producto.tipo != null">
            <label>{{issue.producto.tipo.categoria.name}} - {{issue.producto.tipo.name}}</label>
          </li>
          <li></li>
          <li>
            <label>Lote: {{issue.producto.lote}}</label>
          </li>
          <li>
            <label>Caducidad: {{issue.producto.fechaCaducidad}}</label>
          </li>
          <li>
            <label>Centro:</label>
            <ul class="list-data">
              <li>{{issue.centro.nombre}}</li>
              <li>
                <label>{{issue.centro.domicilio}}</label>
              </li>
              <li>
                <label>{{issue.centro.municipio}} - {{issue.centro.provincia}}</label>
              </li>
            </ul>
          </li>
          <li class="visor-obervaciones">
            <label>Observaciones: {{issue.incidencia.observaciones}}</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { SectionPanel } from "@/components";

export default {
  name: "issue-producto",
  components: { SectionPanel },
  props: {
    issue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    getProductImageUrl() {
      if (this.issue.producto != null && this.issue.producto.tipo != null) {
        return staticServer + this.issue.producto.tipo.image;
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list-data {
  list-style: none;
  padding: 10px;
  margin: 0px;
}
.visor-obervaciones {
  max-height: 140px;
  overflow: auto;
}
.linea{
  border-bottom: #e0f3e7 solid 1px;
  width:100%;padding-bottom: 0px;
  margin-top: -15px;
}
.cabecera{
  padding-bottom: 0%;
  padding-left: 10px;
  padding-top: 10px;
  font-weight: bold;
  font-size: 15px;
  color:#2a6917;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 30px;
  width: 190px;
  background-color: #e0f3e7;
}
</style>


